import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class InstallSingletonsAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.installer.installSingletons();
    }

    getName(): string {
        return 'InstallSingletonsAct';
    }
}